import React, { useState, useEffect, useRef } from "react";
import ExpertCard from "./ExpertCard";
import NavigationArrows from "./NavigationArrows";
import styles from "./styles.module.css";

const DesktopExperts = ({ experts }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isEndOfrightScroll, setEndOfrightScroll] = useState(false);
  const [isEndOfLeftScroll, setEndOfLeftScroll] = useState(true);
  const [padding, setPadding] = useState(0);
  const scrollRef = useRef();
  const headerRef = useRef();

  const updateWidth = () => {
    const profsColumnsEl = document.getElementById("profsColumns");
    if (!profsColumnsEl) {
      return;
    }

    const profsWidth = profsColumnsEl.offsetWidth;
    const el = scrollRef.current;
    const padding = (el.clientWidth - profsWidth) / 2;
    setPadding(padding);
    el.style.padding = `0px ${padding}px 40px ${padding}px`;
    headerRef.current.style.width = `${profsWidth}px`;
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener("resize", updateWidth, false);
  }, []);

  const useScroll = () => {
    useEffect(() => {
      const el = scrollRef.current;
      el.scrollTo({ left: scrollPosition });
      setEndOfrightScroll(
        el.scrollWidth !== el.clientWidth &&
          Math.abs(el.scrollLeft + el.clientWidth - el.scrollWidth) < 5
      );
      setEndOfLeftScroll(el.scrollLeft === 0);
      if (el) {
        const onScroll = (e) => {
          //   e.preventDefault();
          setScrollPosition(el.scrollLeft);
        };
        el.addEventListener("wheel", onScroll);
        return () => el.removeEventListener("wheel", onScroll);
      }
    }, [scrollPosition]);
    return scrollRef;
  };

  const setTeamCard = (direction) => {
    const el = scrollRef.current;
    if (el?.scrollWidth) {
      const cardWidth =
        parseInt((+el.scrollWidth - padding * 2) / experts.length) + 3;
      const currnetCard = parseInt(scrollPosition / cardWidth);
      setScrollPosition(
        direction === "next"
          ? (currnetCard + 1) * cardWidth
          : (currnetCard - 1) * cardWidth
      );
    }
  };
  const renderCards = experts.map((expert, i) => (
    <ExpertCard key={i} expert={expert} />
  ));

  return (
    <div className={styles.root}>
      <div className={styles.headerWrapper}>
        <div ref={headerRef} className={styles.header}>
          <div className={styles.containerForTitle}>
            <div className={styles.flex}>
              <div className={styles.title}>Эксперты</div>
            </div>
            <div className={styles.text}>
              Главные действующие лица криптоиндустрии, пережившие все булраны и
              зимовки.
            </div>
          </div>
          <NavigationArrows
            isPrev={!isEndOfLeftScroll}
            isNext={!isEndOfrightScroll}
            prev={() => setTeamCard("prev")}
            next={() => setTeamCard("next")}
          />
        </div>
      </div>
      <div className={styles.sliderWrapper}>
        <div ref={useScroll()} className={styles.slider}>
          {renderCards}
        </div>
      </div>
    </div>
  );
};

export default DesktopExperts;
